<template>
  <v-app>
    <v-app-bar app fixed dense flat clipped-left class="tb d-print-none">
      <router-link to="/"><v-toolbar-title to="/">Quiz</v-toolbar-title></router-link>
      <v-spacer></v-spacer>
      <v-btn icon v-if="sharable()" @click="share" aria-label="teilen">
              <v-icon>{{sharer}}</v-icon>
      </v-btn>
    </v-app-bar>

    <vue-progress-bar></vue-progress-bar>
    
     <v-content class="content">
      <v-container fluid fill-height>
        <v-layout>
          <v-flex>
            <main>
              <router-view id="print"></router-view>
            </main>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <div v-if="this.$Progress.$vm.RADON_LOADING_BAR.percent==100">{{showwarning=true}}</div>
  </v-app>
</template>

<style scoped>
.tc{
  text-align: center;
}
@media print {
  .content {padding: 0 !important; z-index: 10;}
}
#list{
  overflow-x: auto;
  word-wrap: break-word;
}
</style>


<script>
import { mdiShareVariant } from '@mdi/js'
import { mdiPrinter } from '@mdi/js'
import { mdiMagnify } from '@mdi/js'
import { mdiThemeLightDark } from '@mdi/js'
  export default {
    name: 'App',
    data: () => ({
      sharer: mdiShareVariant,
      printer: mdiPrinter,
      magnify: mdiMagnify,
      theme: mdiThemeLightDark,
      drawer: null,
      printer_off: true,
      showwarning: false
    }),
    props: {
      source: String
    },
    methods: {
      navigate: function(){
        if(this.$router.currentRoute.path!=='/funktionen/suche'){
        this.$router.push('/funktionen/suche')
        } else{
        this.$router.go(-1)
        }
      },
      print: function(){
        try {
          // Print for Safari browser
          document.execCommand('print', false, null)
        } catch {
          window.print()
        }
      },
      sharable: function(){
        if(navigator.share){
          return true;
        } else {
          return false;
        }
      },
      share: function(){
        if(navigator.share){
          navigator.share({
            url: "https://quiz.lernzettel.org" + this.$router.currentRoute.path
          })
        }
      }
    },
    metaInfo: {
      title: 'Lernzettel - Quiz',
      // all titles will be injected into this template
      titleTemplate: '%s'
    },
    created(){
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start()

    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        this.$Progress.parseMeta(meta)
      }
      this.$Progress.start()
      next()
    })
    }
  }
</script>
